import React from "react";
import styles from "./style.module.scss";
import Layout from "../../components/Layout/authenticatedLayout";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../state";
import { setVolume, setPlaybackSpeed, setZoom } from "../../state/radioReducer";

import RadioDataManager from "../../components/DataManagers/RadioDataManager";
import RadioSelectorBar from "../../components/Radio/RadioSelectorBar";
import RadioWaveform from "../../components/Radio/RadioWaveform";
import RadioPlayControls from "../../components/Radio/RadioPlayControls";
import RadioSlider from "../../components/Radio/RadioSlider";

function RadioPage() {
  const dispatch = useDispatch();
  const volume = useSelector((state: RootState) => state.radio?.volume ?? 1);
  const playbackSpeed = useSelector(
    (state: RootState) => state.radio?.playbackSpeed ?? 1,
  );
  const zoom = useSelector((state: RootState) => state.radio?.zoom ?? 100);
  const minZoom = useSelector((state: RootState) => state.radio?.minZoom ?? 1);
  const maxZoom = useSelector(
    (state: RootState) => state.radio?.maxZoom ?? 200,
  );
  const isWaveformLoading = useSelector(
    (state: RootState) => state.radio?.isWaveformLoading,
  );

  return (
    <Layout title={"Radio"} showJaguarLogo={false}>
      <RadioDataManager />
      <div className={styles.container}>
        <RadioWaveform />
        <div className={styles.overlay}>
          <RadioSelectorBar />
          <RadioSlider
            title="Volume"
            min={0}
            max={1}
            step={0.1}
            value={volume}
            defaultValue={1}
            onChange={(v) => dispatch(setVolume(v))}
            disabled={isWaveformLoading}
          />
          <RadioSlider
            title="Speed"
            min={0.5}
            max={3}
            step={0.25}
            value={playbackSpeed}
            defaultValue={1}
            onChange={(v) => dispatch(setPlaybackSpeed(v))}
            disabled={isWaveformLoading}
          />
          <RadioSlider
            title="Zoom"
            min={minZoom}
            max={maxZoom}
            value={zoom}
            defaultValue={100}
            onChange={(v) => dispatch(setZoom(v))}
            disabled={isWaveformLoading}
            showValue={false}
          />
        </div>
        <div className={styles.playControls}>
          <RadioPlayControls />
        </div>
      </div>
    </Layout>
  );
}

export default RadioPage;
